import { IconButton, Tooltip, Modal, Box, Typography } from "@mui/material";
import React, { useContext, useState } from "react";
import { useTranslation } from "react-i18next";
import DOMPurify from "dompurify"; // Importamos DOMPurify

import AppContext from "../../Contexts/AppContext";

import CloseIcon from "@mui/icons-material/Close";

export const Attributions = () => {
  const { t, i18n } = useTranslation("main");
  const { layersGroupsRef, attributionsRef } = useContext(AppContext);
  const [open, setOpen] = useState(false);

  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);

  const isMobile = window.innerWidth < 960;

  const attributions = layersGroupsRef.current
    .filter((layerGroup) => layerGroup.visible) // Filtrar solo grupos visibles
    .flatMap((layerGroup) =>
      layerGroup.layers
        .filter((layer) => layer.visible) // Filtrar solo capas visibles dentro de grupos visibles
        .map((layer) => ({
          name: layer.name[i18n.language] || layer.name.en, // Nombre en el idioma actual
          attribution:
            layer.attribution_html[i18n.language] || layer.attribution_html.en, // Atribución en el idioma actual
        }))
    )
    .filter((attr) => attr.attribution && attr.attribution.trim() !== ""); // Filtrar atribuciones vacías o null

  return (
    <>
      <Tooltip title={t("show_layer_attributions")} placement="top">
        <IconButton
          ref={attributionsRef}
          className="mapButton"
          style={{
            position: "absolute",
            left: "0.5rem",
            bottom: "5rem",
            width: "2rem",
            height: "2rem",
          }}
          onClick={handleOpen}
        >
          i
        </IconButton>
      </Tooltip>

      <Modal open={open} onClose={handleClose}>
        <Box
          sx={{
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            width: 400,
            bgcolor: "background.paper",
            boxShadow: 24,
            p: "1rem",
            borderRadius: "8px",
            maxHeight: "80vh",
            overflowY: "auto",
            maxWidth: "90vw",
          }}
        >
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              gap: "1rem",
              paddingBottom: "1rem",
              position: "relative",
            }}
          >
            {!isMobile && (
              <IconButton
                style={{
                  position: "absolute",
                  right: "0",
                }}
                onClick={handleClose}
              >
                <CloseIcon />
              </IconButton>
            )}
            <Typography variant="h6" component="h2" gutterBottom>
              {t("layer_attributions")}
            </Typography>
          </div>

          {attributions.length > 0 ? (
            attributions.map((attr, index) => (
              <Box key={index} sx={{ mb: 2 }}>
                <Typography variant="subtitle1" sx={{ fontWeight: "bold" }}>
                  {attr.name}
                </Typography>
                <div
                  dangerouslySetInnerHTML={{
                    __html: DOMPurify.sanitize(attr.attribution),
                  }}
                />
              </Box>
            ))
          ) : (
            <Typography variant="body2">{t("no_attributions")}</Typography>
          )}
        </Box>
      </Modal>
    </>
  );
};
